import {
  buildCompanyHeaders,
  getStoredCompanyId,
} from "./companyWorkspace";

export const downloadCronExecutionResultCsv = async ({
  serverUrl,
  logId,
  token,
  fetchImpl = fetch,
}) => {
  const id = logId != null ? String(logId) : "";
  if (!id) {
    throw new Error("Missing execution log id");
  }

  const result = await fetchImpl(
    `${serverUrl}/cronJobExecutionLog/downloadResult/${id}`,
    {
      method: "GET",
      headers: buildCompanyHeaders(
        {
          Accept: "text/csv",
          ...(token ? { "x-access-token": token } : {}),
        },
        getStoredCompanyId()
      ),
    }
  );

  if (!result.ok) {
    const contentType = result.headers.get("Content-Type") ?? "";
    let message = `Download failed (${result.status || "unknown"})`;
    if (contentType.includes("application/json")) {
      const errorBody = await result.json();
      message =
        errorBody?.error?.message ||
        errorBody?.error?.msg ||
        errorBody?.error ||
        errorBody?.message ||
        message;
    }
    throw new Error(message);
  }

  const blob = await result.blob();
  const blobUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  const contentDisposition = result.headers.get("Content-Disposition");
  let fileName = `cron-execution-${logId}.csv`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename=(.+)/);
    if (match?.[1]) fileName = match[1];
  }
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(blobUrl);
};
